<template>
  <i-input
    v-model="myValue"
    type="textarea"
    :autosize="{ minRows: 3, maxRows: 6 }"
    class="json-input"
    :placeholder="placeholder"
    @on-blur="changeValue"
  />
</template>

<script>
export default {
  name: 'KeyValueTextare',
  props: {
    value: { type: [Object, String], default: () => {} },
    placeholder: { type: String, default: 'Enter headers' },
  },

  data() {
    return {
      myValue: '',
    }
  },

  computed: {
    valueIsString() {
      return typeof this.value === 'string'
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newV) {
        if (!newV) {
          this.myValue = ''
          return
        }
        if (this.valueIsString) {
          this.myValue = newV
        } else {
          // json-objectwoz
          const kvList = Object.entries(newV)
          let str = ''
          for (let i = 0; i < kvList.length; i += 1) {
            const item = kvList[i]
            const k = item[0]
            const v = item[1] || ''
            const kv = `${k}:${v}`
            str += `${kv}\n` // '\n' difference
          }
          this.myValue = str.slice(0, str.length - 1) // end without '\n'
        }
      },
    },
  },

  methods: {
    changeValue() {
      if (!this.myValue) {
        const res = this.valueIsString ? '' : {}
        this.$emit('input', res)
        return
      }
      if (this.valueIsString) {
        this.$emit('input', this.myValue)
      } else {
        const str = this.myValue
        const obj = {}

        const kvList = str.split('\n') // '\n' difference
        for (let i = 0; i < kvList.length; i += 1) {
          const kvString = kvList[i]
          const ii = kvString.indexOf(':')
          if (kvString) {
            let k = ''
            let v = ''
            if (ii > -1 && kvString.slice(0, ii)) {
              // key-value include ':'
              k = kvString.slice(0, ii).trim()
              v = kvString.slice(ii + 1).trim()
            } else {
              k = kvString
            }
            obj[k] = v
          }
        }
        this.$emit('input', obj)
      }
    },
  },
}
</script>
